import { DrawerBody, Tabs, Tab } from "@growtherapy/sprout-ui";
import { ClientInformationTabWrapper as ClientInformationTab } from "./ClientInformationTab";
import { UpcomingClientAppointmentsTabWrapper as UpcomingClientAppointmentsTab } from "./client-appointments-tab/UpcomingClientAppointmentsTab";
import { TreatmentTabWrapper as TreatmentTab } from "./treatment-tab/TreatmentTab";
import { ClientInformationDrawerBodyContentWrapper as ClientInformationDrawerBodyContent } from "./ClientInformationDrawerBodyContentWrapper";
import { useAtom } from "jotai";
import { activeClientInformationTabAtom } from "./state";
import { ClientInformationDrawerTab } from "../state";
import {
  faCalendar,
  faHeadSideMedical,
  faIdCardClip,
} from "@fortawesome/pro-solid-svg-icons";
import { shouldUseSeedlingClientInfoDrawer } from "../../statsig/gates";
import { useFeatureGate } from "@statsig/react-bindings";

export function ClientInformationDrawerBody({
  tabContent,
  setActiveTab,
  activeTab,
  isEmpty,
  shouldShowNewDrawerBody,
}: {
  tabContent: React.ReactNode;
  setActiveTab: (tab: ClientInformationDrawerTab) => void;
  activeTab: ClientInformationDrawerTab;
  isEmpty: boolean;
  shouldShowNewDrawerBody: boolean;
}) {
  return (
    <>
      {shouldShowNewDrawerBody ? (
        <DrawerBody>
          <ClientInformationDrawerBodyContent isEmpty={isEmpty} />
        </DrawerBody>
      ) : (
        <DrawerBody className="sm:max-w-lg">
          <div className="w-full flex justify-center">
            <Tabs
              selectedTabId={activeTab}
              onSelectTab={(newTab: ClientInformationDrawerTab) => {
                setActiveTab(newTab);
              }}
            >
              <Tab
                tabId={ClientInformationDrawerTab.INFORMATION}
                className="whitespace-nowrap px-1"
                icon={faIdCardClip}
                title="Overview"
              />
              <Tab
                tabId={ClientInformationDrawerTab.TREATMENT}
                className="whitespace-nowrap px-1"
                icon={faHeadSideMedical}
                title="Treatment"
              />
              <Tab
                tabId={ClientInformationDrawerTab.APPOINTMENTS}
                className="whitespace-nowrap px-1"
                icon={faCalendar}
                title="Appointments"
              />
            </Tabs>
          </div>
          <div className="pt-5 flex flex-col w-full">{tabContent}</div>
        </DrawerBody>
      )}
    </>
  );
}

export function ClientInformationDrawerBodyWrapper({
  isEmpty,
}: {
  isEmpty: boolean;
}) {
  // NOTE: This atom is only consumed by the old drawer body, when
  // `shouldShowNewDrawerBody` is false. When we fully release the
  // `shouldUseSeedlingClientInfoDrawer` FF, we can fully remove this atom.
  const [activeTab, setActiveTab] = useAtom(activeClientInformationTabAtom);
  const { value: shouldShowNewDrawerBody } = useFeatureGate(
    shouldUseSeedlingClientInfoDrawer,
  );
  const clientTabMap = {
    [ClientInformationDrawerTab.INFORMATION]: (
      <>
        <ClientInformationTab isEmpty={isEmpty} />
      </>
    ),
    [ClientInformationDrawerTab.TREATMENT]: (
      <>
        <TreatmentTab />
      </>
    ),
    [ClientInformationDrawerTab.APPOINTMENTS]: (
      <>
        <UpcomingClientAppointmentsTab />
      </>
    ),
  };

  const tabContent = clientTabMap[activeTab];
  return (
    <ClientInformationDrawerBody
      activeTab={activeTab}
      setActiveTab={setActiveTab}
      tabContent={tabContent}
      isEmpty={isEmpty}
      shouldShowNewDrawerBody={shouldShowNewDrawerBody}
    />
  );
}
